var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 19,
    cy: 19,
    r: 19
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#D8DFE3",
    strokeWidth: 0.5,
    cx: 22,
    cy: 22,
    r: 21.75
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#009ED7",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.13 19.556v-8.37h11.544v5.864c0 2.662-.3 4.474-.9 5.437-.599.963-1.5 1.296-2.703 1-.097.986-.097 1.681 0 2.086.097.404.333.696.708.873-.826.986-2 1.479-3.523 1.479-1.522 0-2.697-.493-3.523-1.479l-1.603-6.89z",
    fill: "#FFE2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.07 23.487a8.41 8.41 0 0 1-1.849-.53c-.89-.37-1.91-1.198-1.976-1.122-.066.076.554 1.28 1.479 1.917.616.424 1.374.692 2.274.802l.073-1.067z",
    fill: "#FFD5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.78 26.446c3.695 1.543 5.853 2.67 6.473 3.38.62.711 1.002 1.963 1.147 3.758C29.289 36.528 25.597 38 19.323 38S9.277 36.902 8.005 34.707c.09-1.935.41-3.418.957-4.449.547-1.031 2.804-2.302 6.771-3.812h7.046z",
    fill: "#004BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.674 17.05c.087-1.808-.126-2.888-.641-3.241-.772-.53-1.59 0-3.266-.042-1.118-.028-2.141-.481-3.071-1.358.05 1.27-.185 2.22-.706 2.848-.78.942-1.434.053-2.569.189s-1.287 1.47-.898 2.621c.26.768.875 1.156 1.846 1.164v6.31c-.801 1.328-2.058 1.82-3.772 1.477-1.713-.345-2.65-1.512-2.814-3.502-1.64-.185-2.715-.958-3.223-2.318-.76-2.04.624-3.011.762-4.243.138-1.231-.943-1.984-.322-3.359.62-1.374 2.512-1.619 3.056-2.256.543-.637-.144-1.373 1.543-2.521 1.687-1.149 4.367-.163 5.11-.26.743-.098 4.07-1.391 6.709-.81 2.64.583 4.794 1.898 4.794 4.57 0 1.781-.846 3.358-2.538 4.731z",
    fill: "#AE4BD7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fa3348863a5274026c2e299e57982161.svg";
export { ForwardRef as ReactComponent };